export default {"src":"/_next/static/media/img-blog-mask-back.21f1fc72.svg","height":300,"width":300};